"use client";
import { useState } from "react";
import Link from "next/link";
import BookAuditCallButton from "../components/BookAuditCallButton";
import EmailPromptModal from "../components/EmailPromptModal";
import ReportModal from "../components/ReportModal";

export default function HomeCTA() {
  const [isEmailPromptOpen, setIsEmailPromptOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [reportEmail, setReportEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const handleEmailSubmit = (email: string) => {
    setReportEmail(email);
    setEmailError("");
    setIsEmailPromptOpen(false);
    setIsReportModalOpen(true);
  };

  const handleReportError = (message: string) => {
    setIsReportModalOpen(false);
    setEmailError(message);
    setIsEmailPromptOpen(true);
  };

  return (
    <section className="w-full bg-surface py-16 px-6 md:px-10 lg:px-16">
      <div className="max-w-5xl mx-auto">
        <div className="relative bg-surface-inverse rounded-3xl px-6 sm:px-10 py-12 sm:py-16 lg:py-20 text-center overflow-hidden">
          <div className="relative z-10">
            <h2 className="font-display text-[28px] sm:text-[36px] lg:text-[48px] font-black text-accent-ink leading-tight tracking-[-0.02em] mb-4 text-balance">
              Be one of the names AI recommends.
            </h2>
            <p className="text-[14px] sm:text-[15px] text-accent-ink/70 mb-8 sm:mb-10">
              Join forward-thinking brands capturing the future of visibility.
            </p>

            <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4 mb-6">
              <BookAuditCallButton
                label="Book a Call"
                className="w-full sm:w-auto px-7 py-3.5 bg-accent-ink text-surface-inverse font-semibold text-[15px] rounded-xl active:scale-[0.97] transition-transform duration-[160ms] [transition-timing-function:var(--ease-out)] hover:opacity-90 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-ink focus-visible:ring-offset-2 focus-visible:ring-offset-surface-inverse"
              />
              <Link
                href="/audit"
                data-guide-land
                className="w-full sm:w-auto inline-flex items-center justify-center px-7 py-3.5 border border-accent-ink/40 text-accent-ink font-semibold text-[15px] rounded-xl active:scale-[0.97] transition-transform duration-[160ms] [transition-timing-function:var(--ease-out)] hover:bg-accent-ink/10 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-ink focus-visible:ring-offset-2 focus-visible:ring-offset-surface-inverse"
              >
                Get Free Audit Report
              </Link>
            </div>

            <p className="text-[13px] text-accent-ink/60">
              Book a 30-min call to see your AI-search gap live, or get a free report on how ChatGPT and Google AI Overviews see your brand. No commitment.
            </p>
          </div>
        </div>
      </div>

      <EmailPromptModal
        isOpen={isEmailPromptOpen}
        onClose={() => setIsEmailPromptOpen(false)}
        onSubmit={handleEmailSubmit}
        initialError={emailError}
      />
      <ReportModal
        isOpen={isReportModalOpen}
        onClose={() => setIsReportModalOpen(false)}
        userEmail={reportEmail}
        onError={handleReportError}
      />
    </section>
  );
}
